var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"Build bei Netlify ausführen","action":"create","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('div',{staticClass:"flex flex-col w-full mb-2"},[_vm._v(" Soll ein neuer Build bei Netlify angestoßen werden? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }